'use client';

import React, { createContext, useContext, useState } from 'react';

export type AppEnvironment = 'webapp_staging' | 'webapp_production';

// Map dropdown value to app_logs environment column value
export const ENV_TO_LOG_ENV: Record<AppEnvironment, string> = {
  webapp_staging: 'staging',
  webapp_production: 'production',
};

interface EnvironmentContextValue {
  environment: AppEnvironment;
  setEnvironment: (env: AppEnvironment) => void;
  logEnv: string; // the value used to filter app_logs.environment
}

const EnvironmentContext = createContext<EnvironmentContextValue>({
  environment: 'webapp_staging',
  setEnvironment: () => {},
  logEnv: 'staging',
});

export function EnvironmentProvider({ children }: { children: React.ReactNode }) {
  const [environment, setEnvironment] = useState<AppEnvironment>('webapp_staging');

  return (
    <EnvironmentContext.Provider
      value={{
        environment,
        setEnvironment,
        logEnv: ENV_TO_LOG_ENV[environment],
      }}
    >
      {children}
    </EnvironmentContext.Provider>
  );
}

export function useEnvironment() {
  return useContext(EnvironmentContext);
}
